import { useMatches } from "@tanstack/react-router"

import type { GlobalContext, OrgContext } from "@/lib/context.ts"

export function useRootContext(): GlobalContext {
  const matches = useMatches()
  return matches[0].context
}

export function useOrgContext(): OrgContext {
  const matches = useMatches()
  return matches[1].context as OrgContext
}

export function useQueries() {
  const context = useOrgContext()
  return context.queries
}

export function useInvalidateQueries() {
  const queryClient = useRootContext().queryClient
  return queryClient.invalidateQueries.bind(queryClient)
}

export function usePersistence() {
  return useRootContext().persistence
}
